<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-btn
          class="blue"
          dark
          @click="openModalAyuda"
          block
        >
          ¿Ayuda para construir Cuerpo del mensaje?
        </v-btn>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="6"
              >
              <v-select
                  v-model="form.type"
                  :items="itemsType"
                  label="Tipo"
                  placeholder="Mensajes de Texto / Whatsapp"
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required]"
                  :maxlength="100"
                  label="Nombre"
                  placeholder="Proveedor 1"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="form.parameters"
                  label="Parámetros del Proveedor (Formato Json)"
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog
         v-model="dialogAyuda"
         max-width="850"
    >
      <v-layout class="wrap justify-space-around form-body">
        <v-card style="padding: 20px">
          <v-card-title class="headline" style="word-break: break-word">
            ¿Necesitas ayuda para crear la configuración de los parámetros del proveedor?
          </v-card-title>
          <v-card-text>
            Para crear el JSON se deben usar las siguientes claves:
            <ul>
              <li>
                <b>urlbase</b> (url de la api del proveedor),
              </li>
              <li>
                <b>template</b> (Cuerpo del mensaje, dentro del cuerpo se pueden agregar campos
                dinámicos correspondientes a la información de la empresa o del documento emitido)
              </li>
            </ul>
          </v-card-text>
          <v-card-text>
            Ejemplo de <b>JSON</b> valido es el siguiente:<br/>
            <ul>
              <li>
                {
                  "urlbase": "https://servicio.host.com",
                  "template" : "THE FACTORY HKA VENEZUELA le informa que {rifEmisor} {razonSocialEmisor} le ha emitido un documento
                  {tipoDoc} {serie} {numDoc} - N° Control {numControl} que  puede consultar su documento a través del siguiente enlace {urlConsulta}"
                }
              </li>
            </ul>
          </v-card-text>
          <v-card-text>
              En las claves del JSON se pueden colocar campos de la BD según el listado, se deben colocar
              entre <b style="color:royalblue;"> llaves "{}"</b>.<br/>
              Ejemplos de estos campos son los siguientes:<br/><br/>
            <v-col style="column-count: 2;">
              <v-list-item two-line v-for="item in fieldProvider" :key="item.field">
                <v-list-item-content style="font-size: 2rem;">
                    <v-list-item-title>{{item.field}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.text}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="dialogAyuda = false; next=1"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    metaInfo() {
      return { title: this.$t('providers') };
    },
    components: {
      FormToolbar,
    },
    props: {
      id: { default: null },
    },
    data: () => ({
      form: new Form({
        data: {},
        type: '',
        name: '',
        parameters: '',
        active: '1',
      }),
      errores: null,
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      itemsType: [
        { value: 1, text: 'Mensajes de Texto' },
        { value: 2, text: 'Whatsapp' },
      ],
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Proveedor',
      apiURL: '/api/catalogs/providers',
      method: 'POST',
      disabledOnEdit: false,
      dialogAyuda: false,
      fieldProvider: [
          { field: 'rif', text: 'RIF del Receptor' },
          { field: 'razonSocial', text: 'Razón Social del Receptor' },
          { field: 'tipoDoc', text: 'Tipo de Documento' },
          { field: 'serie', text: 'Serie del Documento' },
          { field: 'numDoc', text: 'Número del Documento' },
          { field: 'numControl', text: 'Número de Control del Documento' },
          { field: 'urlConsulta', text: 'url portal consulta del Documento' },
          { field: 'sucursal', text: 'Sucursal del Emisor' },
          { field: 'fechaEmision', text: 'Fecha Emisión del Documento' },
          { field: 'rifEmisor', text: 'RIF del Emisor' },
          { field: 'razonSocialEmisor', text: 'Razón Social del Emisor' },
          { field: 'razonSocialTercero', text: 'Razón Social del Tercero' },
          { field: 'rifTercero', text: 'RIF del Tercero' },
      ],
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      const URL = `${this.apiURL}/store`;
      this.URL = URL;
      if (this.id) {
        this.URL = `${this.apiURL}/${this.id}/update`;
        window.axios.get(`${this.apiURL}/${this.id}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.disabledOnEdit = true;
          this.method = 'PUT';
          this.title = 'Editar Proveedor';
          this.message = `Se ha editado el Proveedor ${result.data.name} exitosamente.`;
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      openModalAyuda() {
        this.dialogAyuda = true;
      },
    },
  };

</script>
